module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/3@2x_11bb2881082d9a8c5991ac52c0bceac5.png";